import {Model} from './model.class';
import {Service} from './service.class';
import {ModelListService} from './model-list.service';
import {Observable} from 'rxjs';
import {Response} from '@angular/http';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class UserModelListService<T extends Model<T>> {

    private _modelService: ModelListService<T>;
    changes$: Observable<boolean>;

    constructor(svcm: Service.InjectedMembers, namespace: string, protected readonly _modelType: Model.Type<T>) {
        this._modelService = new ModelListService<T>(svcm, namespace, _modelType, 'currentUser');
        this.changes$ = this._modelService.changes$;
    }

    getCurrentUserModelEntries(projection?: ProjectionInformation): Observable<Array<T>> {
        return this._modelService.getModelEntries(projection);
    }

    getCurrentUserModelEntryIdsSortedByIndex(): Observable<Array<string>> {
        return this._modelService.getModelEntryIdsSortedByIndex();
    }

    doesCurrentUserModelEntryExist(index: number): Observable<boolean> {
        return this._modelService.doesModelEntryExist(index);
    }

    getCurrentUserModelEntry(index: number, projection?: ProjectionInformation): Observable<T | undefined> {
        return this._modelService.getModelEntry(index, projection);
    }

    updateCurrentUserModelEntry(index: number, model: T): Observable<Response> {
        return this._modelService.updateModelEntry(index, model);
    }

    countCurrentUserModelEntries(): Observable<number> {
        return this._modelService.countModelEntries();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/user-model-list.service.ts